import {
  Home,
  Database,
  LineChart,
  Binoculars,
  Activity,
  CalendarCheck,
  Trophy,
  Users,
  Bomb,
} from "lucide-react";

export const NAV_ITEMS = [
  { icon: Home, path: "/", label: "Home" },
  { icon: Database, path: "/data", label: "Data" },
  { icon: LineChart, path: "/charting", label: "Charting" },
  { icon: Binoculars, path: "/scouting", label: "Scouting" },
  { icon: Users, path: "/recruiting", label: "Recruiting", featureFlag: "recruiting" },
  { icon: Activity, path: "/guts", label: "Guts" },
  { icon: Trophy, path: "/leaderboards", label: "Leaderboards" },
  { icon: CalendarCheck, path: "/scoreboard", label: "Scoreboard" },
  { icon: Bomb, path: "/longball", label: "LongBall", featureFlag: "longball" },
];
